import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=784d0e2e&scoped=true"
import script from "./order-list.vue?vue&type=script&lang=js"
export * from "./order-list.vue?vue&type=script&lang=js"
import style0 from "./order-list.vue?vue&type=style&index=0&id=784d0e2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784d0e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('784d0e2e')) {
      api.createRecord('784d0e2e', component.options)
    } else {
      api.reload('784d0e2e', component.options)
    }
    module.hot.accept("./order-list.vue?vue&type=template&id=784d0e2e&scoped=true", function () {
      api.rerender('784d0e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/order-list.vue"
export default component.exports